import { render, staticRenderFns } from "./AddBuyerModal.vue?vue&type=template&id=72a03820&scoped=true&"
import script from "./AddBuyerModal.vue?vue&type=script&lang=js&"
export * from "./AddBuyerModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBuyerModal.vue?vue&type=style&index=0&id=72a03820&prod&lang=scss&scoped=true&"
import style1 from "./AddBuyerModal.vue?vue&type=style&index=1&id=72a03820&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a03820",
  null
  
)

export default component.exports